[
  {
    "name": "VoteInfo",
    "fieldNames": [
      "proposalVoted",
      "amount"
    ],
    "fieldTypes": [
      "U256",
      "U256"
    ],
    "isMutable": [
      true,
      true
    ]
  },
  {
    "name": "UserRewardSharingInfo",
    "fieldNames": [
      "amount",
      "rewardPerToken"
    ],
    "fieldTypes": [
      "U256",
      "U256"
    ],
    "isMutable": [
      true,
      true
    ]
  },
  {
    "name": "UserStakingInfo",
    "fieldNames": [
      "amount",
      "connectedDapps"
    ],
    "fieldTypes": [
      "U256",
      "ByteVec"
    ],
    "isMutable": [
      true,
      true
    ]
  }
]